"use client";

import { useTheme } from "next-themes";
import { Toaster as SonnerToaster, type ToasterProps } from "sonner";
import { useIsMobile } from "@/hooks/use-mobile";

const toastClassNames = {
  toast:
    "!rounded-2xl !border !border-border !shadow-lg !backdrop-blur-xl !bg-background/85 !text-foreground !py-2.5 !pl-3.5 !pr-10 !gap-2",
  title: "!text-[13px] !font-medium !leading-snug",
  description: "!text-[12px] !opacity-80 !leading-snug",
  icon: "!size-4 shrink-0",
  closeButton:
    "!left-auto !right-2 !top-1/2 !-translate-y-1/2 !translate-x-0 !border !border-border/60 !bg-background/90 !text-muted-foreground hover:!bg-muted hover:!text-foreground hover:!border-border !size-7 !min-h-7 !min-w-7 !rounded-lg !transition-colors",
};

export function Toaster({
  position,
  closeButton = true,
  mobileOffset,
  ...props
}: ToasterProps) {
  const { resolvedTheme } = useTheme();
  const isMobile = useIsMobile();

  const theme = (resolvedTheme === "dark" ? "dark" : "light") as ToasterProps["theme"];

  return (
    <SonnerToaster
      theme={theme}
      closeButton={closeButton}
      position={position ?? (isMobile ? "top-center" : "bottom-right")}
      mobileOffset={
        mobileOffset ?? {
          top: "max(0.5rem, env(safe-area-inset-top))",
        }
      }
      style={{
        ...(isMobile ? { ["--width" as string]: "min(92vw, 420px)" } : {}),
        zIndex: 99999,
      }}
      toastOptions={{
        classNames: toastClassNames,
      }}
      {...props}
    />
  );
}
